export const formatError = (error) => {
  if (typeof error === "string") return error;

  if (Array.isArray(error) && typeof error[0] === "string")
    return error.join(", ");

  if (Object.keys(error || {}).length > 0)
    return "Ett eller flera fält i valt objekt innehåller fel.";
};
